import styled from 'styled-components';

const StatusIconContainer = styled('div')`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 45px;
  top: -45px;
  right: 16px;
  width: 0;
`;

export default StatusIconContainer;
